import { render } from "./EventTagSidebar.vue?vue&type=template&id=23471c7a&scoped=true"
import script from "./EventTagSidebar.vue?vue&type=script&lang=js"
export * from "./EventTagSidebar.vue?vue&type=script&lang=js"

import "./EventTagSidebar.vue?vue&type=style&index=0&id=23471c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23471c7a"]])

export default __exports__